import { PaginatorDatasource } from '@/shared/resources/datasources/paginator/paginator-datasource'
import {
    CommonFilterModel,
    CommonPaginatorResourceService,
    CommonParams
} from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'

export class PaginatorLaboratoryDatasource<T> extends PaginatorDatasource<T> {
    readonly laboratoryId: number

    constructor(service: CommonPaginatorResourceService<T>, laboratoryId: number) {
        super(service)
        this.laboratoryId = laboratoryId
    }

    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<T>> {
        if (!this.service) {
            throw new Error('undefined service')
        }
        return this.service.paginator(filterModel, params, this.laboratoryId)
    }
}
